import VerifyCodeContainer from "../../../../Component/OtherPages/Authentication/VerifyCode/VerifyCode"

const VerifyCode = () => {
  return (
    <div className='page-body'>
      <VerifyCodeContainer />
    </div>
  )
}

export default VerifyCode

